export default "__VITE_ASSET__BJd7YbXK__"